<app-navbar
  *ngIf="!cartDrawerOpen && !isInvoicePage">
</app-navbar>

<router-outlet></router-outlet>


<!-- GLOBAL CART DRAWER -->

<app-cart-drawer
  *ngIf="cartDrawerOpen && !isInvoicePage"
  (closeDrawer)="closeCartDrawer()">
</app-cart-drawer>